import { requirePermissionGuard } from "@/shared/rbac";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/provize")({
  beforeLoad: requirePermissionGuard("hca.provize.read_own"),
});
